import {all, call, put, takeEvery} from '@redux-saga/core/effects'
import {RouteService} from "../../util/services/route";
import {routeActions} from "./reducer";
import {IPois, IRoute} from "../../util/varibles/interface";
import {PayloadAction} from "@reduxjs/toolkit";

function* initialWatcher(args: PayloadAction<{ source_id: string, destination_id: string }>) {
    try {
        const {source_id, destination_id} = args.payload;


        const routes: IRoute[] = yield call(RouteService.getByLocation, source_id, destination_id);
        yield put(routeActions.initialDataSuccess(routes));
    } catch (error) {
        yield put(routeActions.initialDataFailure());
    }
}

function* getLocationsWatcher(): Generator<any, any, IPois[]> {
    try {
        const locations = yield call(RouteService.getLocations);
        yield put(routeActions.getLocationsSuccess(locations))
    } catch (error) {
        yield put(routeActions.getLocationsFailure());
    }
}

export default function* routeSaga() {
    yield all([
        takeEvery(routeActions.initialDataRequest.type, initialWatcher),
        takeEvery(routeActions.getLocationsRequest.type, getLocationsWatcher),
    ])
}
